angular.module('picmonic-common').factory('Contact', [
  '$resource',
  function ($resource) {
    return $resource('/api/v3/contacts');
  },
]);
